import './Howitworks.css';

const steps = [
  {
    num: 1,
    icon: '👤',
    iconBg: '#EFF6FF',
    iconBorder: '#BFDBFE',
    numBg: '#3B82F6',
    title: 'Login or Register with BusinessBay.io',
    description: 'Create your account and start your NFC card journey in seconds.',
  },
  {
    num: 2,
    icon: '⊞',
    iconBg: '#F5F3FF',
    iconBorder: '#DDD6FE',
    numBg: '#8B5CF6',
    title: 'Explore the Dashboard & Go to “Create Card.”',
    description: 'Go to your dashboard and click on “Create Card” to begin.',
  },
  {
    num: 3,
    icon: '🚀',
    iconBg: '#ECFDF5',
    iconBorder: '#A7F3D0',
    numBg: '#10B981',
    title: 'Pick Your Card & Place Your Order',
    description: "Choose your NFC card, and our design team will fully customize it with you.",
  },
   {
    num: 4,
    icon: '📦',
    iconBg: '#fba4745c',
    iconBorder: '#fba474',
    numBg: '#fba474',
    title: 'Receive Your NFC Card',
    description: "Get your brand-new NFC card delivered to your doorstep in a few days.",
  },
];

export default function HowItWorks() {
  return (
    <section className="hiw-section" aria-labelledby="how-to-start-heading" id="how-it-works">
      <div className="hiw-container">

        {/* Header */}
        <div className="hiw-header">
          {/* <span className="hiw-tag">Get Your Customized NFC Business Card in Simple Steps</span> */}
          <h2 className="hiw-title" id="how-to-start-heading">
            Get Your Customized NFC Business Card in Simple Steps
            {/* <span className="hiw-accent"> in Minutes</span> */}
          </h2>
        </div>

        {/* Steps */}
        <div className="hiw-steps-wrapper">
          <div className="hiw-connector" aria-hidden="true" />

          <div className="hiw-steps-grid">
            {steps.map(step => (
              <div key={step.num} className="hiw-step">
                <div className="hiw-icon-wrapper">
                  <div
                    className="hiw-icon-box"
                    style={{ backgroundColor: step.iconBg, borderColor: step.iconBorder }}
                    aria-hidden="true"
                  >
                    {step.icon}
                  </div>
                  <span
                    className="hiw-num-badge"
                    style={{ backgroundColor: step.numBg }}
                  >
                    {step.num}
                  </span>
                </div>

                <h3 className="hiw-step-title">{step.title}</h3>
                <p className="hiw-step-desc">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
